import React, {useState} from "react";
import {Row} from "antd";
import {useFetch} from "../../../hooks/useFetch";
import stores from "../../../store/stores";
import Filters from "./filters/Filters";

import ResponsiveDataTable from "./responsiveDataTable/ResponsiveDataTable";
import ActionButtons from "./actionButtons/ActionButtons";
import {useObserver} from "mobx-react-lite";

const Equipments = () => {
    const [recall, setRecall] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [filters, setFilters] = useState({
        typeId: "all"
    });
    const [loading, equipments] = useFetch({
        fetchFn: stores.equipmentStore.listEquipments.bind(null, {
            limit: 10,
            page: currentPage,
            typeId: filters?.typeId && filters.typeId !== "all" ? filters?.typeId : undefined
        }),
        dependencies: [recall, filters, currentPage]
    });

    return useObserver(() => (
        <div>
            <Row gutter={[8, 8]}>
                <Filters
                    setCurrentPage={setCurrentPage}
                    setFilters={setFilters}
                    filters={filters}
                />
            </Row>
            <Row justify="end">
                <ActionButtons recall={() => setRecall(!recall)} />
            </Row>
            <Row>
                <ResponsiveDataTable
                    loading={loading}
                    data={equipments?.data?.result || []}
                    dataCount={equipments?.data?.total || 0}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    recall={() => setRecall(!recall)}
                />
            </Row>
        </div>
    ));
};

export default Equipments;
